<!-- <mat-form-field  class="special">
  <mat-select  [value]="filtersSelect[0]?.value"
    (selectionChange)="filterChanged.emit($event.value)">
    <mat-option *ngFor="let option of filtersSelect" [value]="option.value">{{ option.label }}</mat-option>
  </mat-select>
</mat-form-field> -->

<curr-dropdown *ngIf="filtersSelect.length" [options]="filtersSelect" [defaultValue]="filtersSelect[0]?.value"
  (valueChange)="filterChanged.emit($event)"></curr-dropdown>